module.exports = __webpack_public_path__ + "static/media/chevron_right.80bc12ba.svg";